import React from 'react';
import ImportDetails from '../components/imports/ImportDetails';

const ImportDetailsPage = () => {
  return (
    <div className="container mx-auto p-4">
      <ImportDetails />
    </div>
  );
};

export default ImportDetailsPage;